function validateMetrics(metrics) {
  const defaults = metrics.filter((metric) => metric.default);
  if (defaults.length > 1) {
    throw new Error(
      `Only one default metric can be set at a time. Found ${defaults.length}`
    );
  }
}
function validateCurrencies(currencies) {
  const withoutKinds = currencies.filter((currency) => currency.kind === null);
  if (withoutKinds.length > 1) {
    throw new Error(
      `Only one currency can be without kind. Found ${withoutKinds.length}`
    );
  }
}

export { validateCurrencies, validateMetrics };
//# sourceMappingURL=config.esm.js.map
